import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "CloudDownload"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M17.6247 16.5H17.2497V15H17.6247C19.4886 15.0745 21.0601 13.6239 21.1347 11.76C21.2092 9.89602 19.7586 8.32454 17.8947 8.24998H17.2497L17.1747 7.63498C16.8305 5.0232 14.604 3.0709 11.9697 3.0709C9.3353 3.0709 7.10885 5.0232 6.76467 7.63498L6.74967 8.24998H6.10467C4.24071 8.32454 2.79011 9.89602 2.86467 11.76C2.93923 13.6239 4.51071 15.0745 6.37467 15H6.74967V16.5H6.37467C3.884 16.4842 1.80577 14.5935 1.55527 12.1154C1.30476 9.6373 2.96255 7.3689 5.39967 6.85498C6.06688 3.74312 8.81709 1.52008 11.9997 1.52008C15.1823 1.52008 17.9325 3.74312 18.5997 6.85498C21.0368 7.3689 22.6946 9.6373 22.4441 12.1154C22.1936 14.5935 20.1153 16.4842 17.6247 16.5ZM12.7497 19.6275V10.5H11.2497V19.6275L9.30722 17.6925L8.24972 18.75L11.9997 22.5L15.7497 18.75L14.6922 17.6925L12.7497 19.6275Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/CloudDownload.vue"]]);
